import { apiGet } from './http'

// ===== GEO 参与板块 =====

/**
 * 参与页：首页总览 + 最近订单
 * GET /app/geo/participate/index
 */
export function fetchGeoParticipateIndex(config = {}) {
  return apiGet(
    '/app/geo/participate/index',
    {},
    {
      silent: true,
      ...config
    }
  )
}

/**
 * 订单页顶部统计
 * GET /app/geo/participate/stat
 */
export function fetchGeoOrderStat(config = {}) {
  return apiGet(
    '/app/geo/participate/stat',
    {},
    {
      silent: true,
      ...config
    }
  )
}

/**
 * 订单分页列表
 * GET /app/geo/participate/page
 * @param {Object} params
 * @param {number} params.pageNum 页码
 * @param {number} params.pageSize 每页条数
 * @param {number} [params.status] 状态 0待激活 1运行中 2已完成 3异常
 */
export function fetchGeoOrderPage(params = {}, config = {}) {
  return apiGet(
    '/app/geo/participate/page',
    params,
    {
      silent: true,
      ...config
    }
  )
}

/**
 * 订单详情
 * GET /app/geo/participate/detail/{orderNo}
 * @param {string} orderNo 订单号
 */
export function fetchGeoOrderDetail(orderNo, config = {}) {
  return apiGet(
    `/app/geo/participate/detail/${orderNo}`,
    {},
    {
      silent: true,
      ...config
    }
  )
}